<template>
    <div>
        <div id="hello-hello">

            <p style="display:inline;float: left;line-height: 22px;"><b>订单列表</b></p>

            <div style="display:inline-block;line-height: 40px;margin: 5px 0;">
                <el-radio-group v-model="btnStatus" @input="searchByStatus">
                    <el-radio-button label="0">待排</el-radio-button>
                    <el-radio-button label="1">已排</el-radio-button>
                    <el-radio-button label="2">生产</el-radio-button>
                    <el-radio-button label="3">暂停</el-radio-button>

                    <el-radio-button label="4">产中停</el-radio-button>
                    <el-radio-button label="5">返工</el-radio-button>
                    <el-radio-button label="6">完成</el-radio-button>

                    <el-radio-button label="-1">全部</el-radio-button>
                </el-radio-group>
            </div>

            <div style="display:inline;">-</div>

            <div style="display:inline-block;width: 300px;">
                <el-input placeholder="请输入订单编号/产品名称" v-model="queryValue" class="input-with-select">
                    <el-button slot="append" icon="el-icon-search" @click="searchOrderProcess"></el-button>
                </el-input>
            </div>
        </div>

        <el-table :data="orderList" style="width: 100%" @select="selectClick" @row-click="rowClick" ref="orderTable"
            highlight-current-row>
            <el-table-column type="selection" width="45" label-class-name="DisabledSelection">
            </el-table-column>

            <el-table-column prop="orderCode" label="订单编号" min-width="9%">
            </el-table-column>
            <el-table-column prop="productName" label="产品名称" min-width="25%">
            </el-table-column>

            <el-table-column prop="equipmentName" label="设备" min-width="6%">
            </el-table-column>
            <el-table-column prop="status" label="状态" min-width="6%">
            </el-table-column>
            <el-table-column prop="completeCount" label="完成数" min-width="6%" align="center">
            </el-table-column>
            <el-table-column prop="remark" label="备注" min-width="11%">
            </el-table-column>
        </el-table>

        <!-- 分页（上） -->
        <div>
            <el-pagination background :page-size="pageNum" :page-count="pageCount"
                layout="total, sizes, prev, pager, next" :total="total" @current-change="pageClick"
                :page-sizes="[4, 5, 10, 15]" @size-change="handleSizeChange">
            </el-pagination>
        </div>

        <div id="hello-hello">
            <p style="display:inline;float: left;line-height: 22px;"><b>设备列表</b></p>

            <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;">
                <el-button round @click="cancelClick">撤销排产</el-button>
            </p>

            <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;">
                <el-button type="primary" round @click="completeClick" :disabled="completeBtnDisable">完成</el-button>
                <span>-</span>
            </p>

            <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;">
                <el-button type="primary" round @click="producingStopClick"
                    :disabled="producingBtnDisable">产中停</el-button>
                <span>-</span>
            </p>

            <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;">
                <el-button type="primary" round @click="inspectionClick" :disabled="inspBtnDisable">首检</el-button>
                <span>-</span>
            </p>

            <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;">
                <el-button type="primary" round @click="startClick" :disabled="startBtnDisable">上机</el-button>
                <span>-</span>
            </p>

            <p style="display:inline;float: right;line-height: 40px;margin: 5px 25%;">
                <el-button type="success" round @click="lineUpClick" :disabled="lineUpBtnDisable">订单排产</el-button>
            </p>
        </div>

        <el-table :data="equipmentList" style="width: 100%" @select="selectEquipClick" @row-click="rowEquipClick"
            ref="equipmentTable" highlight-current-row>
            <el-table-column type="selection" width="45" label-class-name="DisabledSelection">
            </el-table-column>

            <el-table-column prop="equipmentName" label="设备名称" min-width="12%">
            </el-table-column>
            <el-table-column prop="statusDes" label="设备状态" min-width="6%" align="center">
            </el-table-column>

            <el-table-column prop="productName" label="产品" min-width="21%">
            </el-table-column>

            <el-table-column prop="orderCount" label="订单数" min-width="6%" align="center">
            </el-table-column>
            <el-table-column prop="completeCount" label="完成数" min-width="6%" align="center">
            </el-table-column>

            <el-table-column prop="startTime" label="上机时间" min-width="9%">
            </el-table-column>

            <el-table-column prop="productOne" label="排队1" min-width="20%">
            </el-table-column>
            <el-table-column prop="productTwo" label="排队2" min-width="20%">
            </el-table-column>
        </el-table>

        <!-- 分页（下） -->
        <div>
            <el-pagination background :page-size="equipPageNum" :page-count="equipPageCount"
                layout="total, sizes, prev, pager, next" :total="equipTotal" @current-change="equipPageClick"
                :page-sizes="[5, 10, 15, 20]" @size-change="equipHandleSizeChange">
            </el-pagination>
        </div>

        <el-dialog title="首检详情" :visible.sync="inspDialogVisible" width="45%">

            <div
                style="background-color: #f5f7fa;font-size: 14px;text-align:left;padding: 15px 0 15px 10px;margin-bottom: 10px;">
                <span>当前选择的设备编号：</span>
                <span style="color:green;font-weight: bold;">{{ form.equipmentCode }} </span>
                <span>产品：</span>
                <span style="color:green;font-weight: bold;">{{ form.productName }}</span>
            </div>

            <div style="display:flex;margin-bottom: 10px;">
                <p style="display:inline;margin-right: 10px;">* 上传图片</p>

                <div style="display:inline-block;width:132px">
                    <el-upload class="avatar-uploader" action="#" :http-request="uploadPic" :show-file-list="false"
                        :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">

                        <img v-if="inspectionPicOne" :src="inspectionPicOne" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </div>
            </div>

            <div style="display:flex;margin-bottom: 10px;">
                <p style="display:inline;margin-right: 10px;">* 说明</p>
                <div style="display:inline">
                    <el-input v-model="inspForm.remark" autocomplete="off" type="textarea"
                        style="width:540px"></el-input>
                </div>
            </div>

            <div
                style="background-color: #f5f7fa;color:green;font-size: 14px;text-align:left;padding: 15px 0 15px 10px;">
                首检项目
            </div>

            <div v-for="item in inspectionItemList" :key="item.id" style="display:flex">
                <p style="text-align: left;width:70%">{{ item.inspectionName }}</p>

                <div style="display:inline-block;line-height: 40px;margin: 5px 0;">
                    <el-radio-group v-model="item.status">
                        <el-radio :label="1">正常</el-radio>
                        <el-radio :label="2">异常</el-radio>
                    </el-radio-group>
                </div>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="inspDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveInspClick('ruleForm')">保 存</el-button>
            </div>
        </el-dialog>

        <el-dialog title="生产详情" :visible.sync="dlgFormVisible" width="35%">
            <el-form :model="form" :rules="rules" class="demo-ruleForm" ref="ruleForm">

                <el-form-item label="完成数" :label-width="formLabelWidth" prop="completeCount">
                    <el-input-number v-model="form.completeCount" :precision="0" :step="1" :min="1"
                        :disabled="completeCtDisable" style="width:300px"></el-input-number>
                </el-form-item>

                <el-form-item label="产品" :label-width="formLabelWidth" prop="productName">
                    <el-input v-model="form.productName" autocomplete="off" style="width:300px"
                        :disabled="true"></el-input>
                </el-form-item>

                <el-form-item label="排队1" :label-width="formLabelWidth">
                    <el-select v-model="form.productOne" placeholder="请选择" style="width:300px" value-key="productOne"
                        @change="productOneSelect">
                        <el-option v-for="item in form.productProcessList" :key="item.value" :label="item.productName"
                            :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button style="display:inline;margin: 5px 55% 5px 0;" @click="cancelLineUp">撤销</el-button>

                <el-button @click="dlgFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEquipProcClick('ruleForm')">保 存</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
export default {
    name: "OrderLineUp",
    data() {
        return {
            token: this.getToken(),
            userId: this.getUserId(),
            companyId: this.getCompanyId(),

            queryValue: '',
            orderList: [],
            orderId: '',

            inspDialogVisible: false,
            dlgFormVisible: false,

            procStatus: '0',

            btnStatus: '0',
            //默认不可用
            lineUpBtnDisable: false,
            completeBtnDisable: true,
            producingBtnDisable: true,

            inspBtnDisable: true,
            startBtnDisable: true,

            completeCtDisable: false,
            form: {
                id: '',

                equipmentId: '',
                equipmentCode: '',

                orderCount: 0,
                startTime: '',
                completeCount: 0,
                productProcessList: [],

                orderId: '',
                productName: '',

                orderQueueOne: null,
                productOne: '',

                orderQueueTwo: null,
                productTwo: '',

                orderQueueThree: null,
                productThree: '',
            },
            prepOrderId: '',

            formLabelWidth: '120px',

            equipmentList: [],

            inspectionPicOne: '',
            remark: '',

            inspForm: {
                id: '',
                picFileList: [],
                inspectionPicOne: '',
                remark: '',
                maker: '',
            },
            inspectionItemList: [],

            pageIndex: 0,
            pageNum: 4,
            total: 0,
            pageCount: 0,

            equipPageIndex: 0,
            equipPageNum: 5,
            equipTotal: 0,
            equipPageCount: 0,
        }
    },
    methods: {
        selectClick(selection, row) {

            this.rowClick(row)
        },
        rowClick(row) {
            //console.log(row)

            this.$refs.orderTable.clearSelection()
            this.$refs.orderTable.toggleRowSelection(row)
            this.orderId = row.id
        },
        selectEquipClick(selection, row) {
            // console.log('selectEquipClick()')

            this.rowEquipClick(row)
        },
        rowEquipClick(row) {

            this.startBtnDisable = false

            // console.log('rowEquipClick')
            // console.log(row.startTime)

            //完成了上机操作
            if (row.startTime != null && row.startTime != '') {
                this.inspBtnDisable = false
                this.startBtnDisable = true

                if (row.statusDes == '待机') {//未完成首检操作
                    this.inspBtnDisable = false
                }
            } else {
                if (row.statusDes == '待机') {
                    this.inspBtnDisable = true
                }
            }

            //如果设备的状态为生产
            if (row.statusDes == '生产') {
                //按钮可用
                this.completeBtnDisable = false
                this.producingBtnDisable = false

                this.inspBtnDisable = true
            } else {
                this.completeBtnDisable = true
                this.producingBtnDisable = true
            }

            this.form.id = row.id
            this.form.equipmentId = row.equipmentId

            // console.log('equipmentId')
            // console.log(this.form.equipmentId)

            this.form.orderCount = row.orderCount
            this.form.startTime = row.startTime

            this.form.equipmentCode = row.equipmentCode

            this.form.orderId = row.orderId
            this.form.productName = row.productName

            this.form.orderQueueOne = row.orderQueueOne
            this.form.productOne = row.productOne

            this.form.orderQueueTwo = row.orderQueueTwo
            this.form.productTwo = row.productTwo

            this.form.orderQueueThree = row.orderQueueThree
            this.form.productThree = row.productThree

            this.$refs.equipmentTable.clearSelection()
            this.$refs.equipmentTable.toggleRowSelection(row)
        },
        modifyEquipOrder(val) {

            this.procStatus = val + ''

            var reqPath = '/add'
            if (val == 2) {
                reqPath = '/start'
                this.procStatus = '1'
            } else if (val == 4) {
                reqPath = '/stop'
            } else if (val == 6) {
                reqPath = '/complete'
            }

            // console.log('this.procStatus')
            // console.log(this.procStatus)

            this.$axios({
                method: "post",
                url: "/shiro/equip/order" + reqPath,
                data: {
                    id: this.form.id,
                    equipmentId: this.form.equipmentId,

                    productName: this.form.productName,
                    orderId: this.form.orderId,

                    productOne: this.form.productOne,
                    orderQueueOne: this.form.orderQueueOne,

                    productTwo: this.form.productTwo,
                    orderQueueTwo: this.form.orderQueueTwo,

                    productThree: this.form.productThree,
                    orderQueueThree: this.form.orderQueueThree,

                    orderStatus: this.procStatus,
                    completeCount: this.form.completeCount,

                    prepareOrderId: this.prepOrderId,

                    companyId: this.companyId,
                    userId: this.userId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.$message(data.msg)

                this.equipmentList = []
                this.getAllEquipOrder()

                this.getAllOrder(this.btnStatus)
                this.form.equipmentId = ''

                this.dlgFormVisible = false
            })

        },
        cancelLineUp() {

            this.modifyEquipOrder(0)
        },
        cancelClick() {
            if (this.form.equipmentId == '') {
                this.$message({
                    type: 'info',
                    message: '请选择设备'
                })
                return
            }

            this.openDialog(0)

            this.$axios({
                method: "post",
                url: "/shiro/equip/order/getOne",
                data: {
                    equipmentCode: this.form.equipmentCode,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                // console.log(data)

                this.form.productProcessList = data.data.orderQueueList
            })

        },
        lineUpClick() {
            if (this.form.equipmentId == '') {
                this.$message({
                    type: 'info',
                    message: '请选择设备'
                })
                return
            }

            if (this.orderId == '') {
                this.$message({
                    type: 'info',
                    message: '请先选择要排队的订单'
                })
                return
            }

            this.prepOrderId = this.orderId

            this.modifyEquipOrder(1)
        },
        startClick() {
            if (this.form.equipmentId == '') {
                this.$message({
                    type: 'info',
                    message: '请选择设备'
                })
                return
            }

            if (this.form.productOne == null || this.form.productOne == '') {
                this.$message({
                    type: 'info',
                    message: '当前设备没有需要生产的订单'
                })
                return
            }

            this.prepOrderId = ''

            this.modifyEquipOrder(2)
        },
        //首检
        inspectionClick() {
            if (this.form.equipmentId == '') {
                this.$message({
                    type: 'info',
                    message: '请选择设备'
                })
                return
            }

            if (this.form.startTime == null || this.form.startTime == '') {
                this.$message({
                    type: 'info',
                    message: '请先完成上机操作'
                })
                return
            }

            this.getInspection()

            this.inspDialogVisible = true
        },
        getInspection() {

            this.$axios({
                method: "post",
                url: "/shiro/order/inspection/get",
                data: {
                    orderId: this.form.orderId,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                var procInsp = data.data

                if (procInsp != null) {
                    this.inspForm.id = procInsp.id
                    this.inspForm.remark = procInsp.remark

                    this.getInspectionItem(procInsp.id)
                }
            })
        },
        getInspectionItem(val) {

            this.$axios({
                method: "post",
                url: "/shiro/inspection/item/getAll",
                data: {
                    orderInspectionId: val,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.inspectionItemList = data.data
            })
        },
        uploadPic(f) {
            // this.imgFile = f.file
            this.inspForm.picFileList.push(f.file)
        },
        //保存首检
        saveInspClick() {

            const form = new FormData()

            form.append('id', this.inspForm.id)
            form.append('equipmentId', this.form.equipmentId)

            this.inspForm.picFileList.forEach((value, index) => {
                form.append(`picFiles[${index}]`, value)
            })

            form.append('remark', this.inspForm.remark)

            this.inspectionItemList.forEach((value, index) => {
                form.append(`orderInspectionItemList[${index}].id`, value.id)
                form.append(`orderInspectionItemList[${index}].status`, value.status)
            })

            form.append('maker', this.userId)
            form.append('companyId', this.companyId)

            this.$axios({
                method: "post",
                url: "/shiro/order/inspection/modify",
                data: form,
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.inspDialogVisible = false

                this.getAllEquipOrder()
            })
        },
        openDialog(val) {
            this.procStatus = val + ''

            // console.log('openDialog()')

            this.form.productProcessList = []

            //如果有排队的订单，都放入数组中
            if (this.form.productOne) {
                this.form.productProcessList.push({
                    productName: this.form.productOne,
                    orderId: this.form.orderQueueOne
                })
            }

            if (this.form.productTwo) {
                this.form.productProcessList.push({
                    productName: this.form.productTwo,
                    orderId: this.form.orderQueueTwo
                })
            }

            if (this.form.productThree) {
                this.form.productProcessList.push({
                    productName: this.form.productThree,
                    orderId: this.form.orderQueueThree
                })
            }

            this.form.completeCount = this.form.orderCount

            this.dlgFormVisible = true
        },
        productOneSelect(value) {
            // console.log('productOneSelect()')
            // console.log(value)

            this.prepOrderId = value.orderId

            this.form.orderQueueOne = value.orderId
            this.form.productOne = value.productName

            const index = this.form.productProcessList.findIndex(obj => obj.productName == value.productName)
            this.form.productProcessList.splice(index, 1)

            if (this.form.productProcessList.length > 0) {
                this.form.orderQueueTwo = this.form.productProcessList[0].orderId
                this.form.productTwo = this.form.productProcessList[0].productName

                this.form.productProcessList.splice(0, 1)

                if (this.form.productProcessList.length > 0) {

                    this.form.orderQueueThree = this.form.productProcessList[0].orderId
                    this.form.productThree = this.form.productProcessList[0].productName
                }
            }
        },
        saveEquipProcClick() {

            this.modifyEquipOrder(this.procStatus)
        },
        producingStopClick() {

            if (this.form.equipmentId == '') {
                this.$message({
                    type: 'info',
                    message: '请选择设备'
                })
                return
            }

            this.completeCtDisable = false

            this.openDialog(4)
        },
        completeClick() {

            if (this.form.equipmentId == '') {
                this.$message({
                    type: 'info',
                    message: '请选择设备'
                })
                return
            }

            this.completeCtDisable = true

            this.openDialog(6)
        },
        searchOrderProcess() {
            this.searchByStatus(this.btnStatus)
        },
        searchByStatus(val) {
            // console.log('searchByStatus()')

            this.pageIndex = 0
            this.pageNum = 5
            this.form.equipmentId = ''
            this.orderId = ''
            this.prepOrderId = ''

            this.procStatus = val + ''
            
            this.getAllOrder(this.btnStatus)

            this.lineUpBtnDisable = true
            this.completeBtnDisable = true
            this.producingBtnDisable = true

            //如果订单状态为待排、产中停
            if (val == 0 || val == 4) {
                this.lineUpBtnDisable = false
            }

            if (val == 0 || val == 1 || val == 2 || val == 4) {
                this.getAllEquipOrder()
            } else {
                this.equipTotal = 0
                this.equipmentList = []
            }

        },
        //获取订单
        getAllOrder(val) {

            const formData = new FormData()

            formData.append('userId', this.userId)

            formData.append('statusStr', val)
            formData.append('queryParam', this.queryValue)

            formData.append('companyId', this.companyId)
            formData.append('pageIndex', this.pageIndex)
            formData.append('pageNum', this.pageNum)

            this.$axios({
                method: "post",
                url: "/shiro/plastic/order/getAll",
                data: formData,
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                if (data.status === 202) {
                    this.$notify({
                        title: '重要提示',
                        message: data.msg,
                        duration: 0
                    })
                    return
                }

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.orderList = data.data
                this.total = 0
                if (this.orderList.length > 0) {
                    this.total = this.orderList[0].total
                }

                for (let i in this.orderList) {

                    var orderStatus = this.orderList[i].status

                    if (orderStatus == 0) {
                        this.orderList[i].status = '待排'
                    } else if (orderStatus == 1) {
                        this.orderList[i].status = '已排'
                    } else if (orderStatus == 2) {
                        this.orderList[i].status = '生产'
                    } else if (orderStatus == 3) {
                        this.orderList[i].status = '暂停'
                    } else if (orderStatus == 4) {
                        this.orderList[i].status = '产中停'
                    } else if (orderStatus == 5) {
                        this.orderList[i].status = '返工'
                    } else {
                        this.orderList[i].status = '完成'
                    }
                }
            })
        },
        //获取设备订单
        getAllEquipOrder() {
            this.$axios({
                method: "post",
                url: "/shiro/equip/order/getAll",
                data: {
                    status: -1,
                    queryParam: '',
                    pageIndex: this.equipPageIndex,
                    pageNum: this.equipPageNum,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {
                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                this.equipmentList = data.data

                this.equipTotal = this.equipmentList[0].total

                for (let i in this.equipmentList) {
                    if (this.equipmentList[i].startTime) {

                        this.equipmentList[i].startTime = this.$moment(this.equipmentList[i].startTime).format("YYYY-MM-DD HH:mm")

                        if (this.equipmentList[i].startTime == '1970-01-01 08:00:00') {
                            this.equipmentList[i].startTime = ''
                        }
                    }

                    if (this.equipmentList[i].status == 1) {
                        this.equipmentList[i].statusDes = '待机'
                    } else if (this.equipmentList[i].status == 2) {
                        this.equipmentList[i].statusDes = '生产'
                    } else if (this.equipmentList[i].status == 3) {
                        this.equipmentList[i].statusDes = '检修'
                    } else if (this.equipmentList[i].status == 4) {
                        this.equipmentList[i].statusDes = '暂停'
                    } else {
                        this.equipmentList[i].statusDes = '试模'
                    }
                }

            })
        },
        pageClick(currentPage) {
            this.orderList = []

            this.pageIndex = (currentPage - 1) * this.pageNum
            this.getAllOrder(this.btnStatus)
        },
        handleSizeChange(val) {
            this.pageNum = val

            this.getAllOrder(this.btnStatus)
        },
        equipPageClick(currentPage) {
            this.equipmentList = []

            this.equipPageIndex = (currentPage - 1) * this.equipPageNum
            this.getAllEquipOrder()
        },
        equipHandleSizeChange(val) {
            this.equipPageNum = val

            this.getAllEquipOrder()
        },
    },
    mounted() {
        this.setDefaultPath('/orderLineUp')

        this.getAllOrder(this.btnStatus)

        this.getAllEquipOrder()
    }
}
</script>

<style>
.avatar-uploader {
    width: 142px;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 130px;
    height: 130px;
    line-height: 130px;
    text-align: center;
}

.DisabledSelection .el-checkbox__inner {
    display: none;
    position: relative;
}

.el-pagination__total {
    color: green;
}
</style>